export {default} from './TipAvatars';
